import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { SharedProject } from '../../../models/users.model';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-shared-projects-list',
  templateUrl: './shared-projects-list.component.html',
  styleUrls: ['./shared-projects-list.component.scss'],
})
export class SharedProjectsListComponent {
  @Input() list!: SharedProject[];
  @Input() loading: boolean = false;
  @Input() isSelectable: boolean = false; // Enable multi-select mode
  @Output() scrollEvent = new EventEmitter();
  @Output() selectedProjectsChange = new EventEmitter<string[]>(); // Emit selected project IDs

  selectedProjects: string[] = []; // Store selected project IDs

  constructor(public transloco: TranslocoService) {}

  onScroll() {
    this.scrollEvent.emit();
  }

  onSelectionChange() {
    this.selectedProjectsChange.emit(this.selectedProjects);
  }

  protected readonly environment = environment;
}
